import "./style.css";

export default class ReadingBar {
  static selector = ".s-reading-bar";

  constructor(block) {
    this.block = block;
    this.$footer = document.querySelector("footer");
    this.$mobile = document.querySelector(".s-reading-bar-mobile");
  }

  onReady() {
    const type = this.block.getAttribute("data-type");
    if (type === "event") {
      const upcoming = parseInt(this.block.getAttribute("data-upcoming"), 10);
      if (upcoming === 1)
        this.$footer.classList.add("s-footer__has-sticky-event");
    }
  }

  onScroll({ y }) {
    if (this.$mobile) {
      this.$mobile.classList[y > 10 ? "add" : "remove"]("__scrolled");
    }
  }

  onDestroy() {
    this.$footer.classList.remove("s-footer__has-sticky-event");
  }
}
